export default __webpack_public_path__ + "static/media/75t.cf8d3af6.jpg";